<template>
  <div class="text-center leaderboard-wrapper">
    <div v-if="audienceEmoji" class="avatar-bubble">
      <div class="bubble" />
      <span
        class=" layout center horizontal center-justified animate__pulse animate__faster animate__animated animate__infinite"
      >
        {{ audienceEmoji }}
      </span>
    </div>
    <p>{{ $t("alreadyAnswer") }}</p>
    <p>{{ $t("waitAndSeeHowYouDid") }}</p>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['audienceEmoji']),
  },
  mounted() {
    this.audienceCountAnsweredSlideAction()
  },
  methods: {
    ...mapActions(['audienceCountAnsweredSlideAction']),
  },
}
</script>
